import Show from '../Show/Show';
import { FC, PropsWithChildren } from 'react';
import { GRADIENTS, ModuleGradient } from '../../config/designSystem/Colors';
import { GradientView } from '../Gradients/GradientView';
import { ImageBackground, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';

interface GradientWithImageProps extends PropsWithChildren {
  image: string | number | null;
  designSystemColor: string;
  width: number;
  height: number;
  style?: StyleProp<ViewStyle> | undefined;
  light?: boolean;
  resizeMode?: 'cover' | 'contain' | 'stretch' | 'repeat' | 'center';
}

export const GradientWithImage: FC<GradientWithImageProps> = ({
  children,
  width,
  height,
  style,
  designSystemColor,
  image,
  light = false,
  resizeMode = 'cover'
}) => {
  const gradientAll = (GRADIENTS.modules[designSystemColor] as ModuleGradient);
  const gradient = light ? gradientAll?.light : gradientAll?.base;

  return (
    <Show when={!!gradient}>
      <GradientView
        gradient={gradient}
        style={[
          style,
          {
            height: height,
            borderRadius: SPACING['sp-12'],
            width: width,
            position: 'relative', // Ensure proper stacking context
          },
        ]}
      >
        {image && (
          <Show when={!!image}>
            <ImageBackground
              style={[styles.image, { position: 'absolute', width, height, zIndex: 1 }]}
              source={typeof image === 'string' ? { uri: image } : image}
              imageStyle={{
                borderRadius: SPACING['sp-12'], // Apply borderRadius to the image
                resizeMode,
              }}
            />
          </Show>
        )}
        {children}
      </GradientView>
    </Show>
  );
};

const styles = StyleSheet.create({
  image: {
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: -2,
  },
});
